// /scover/member-portal/src/firebase.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBZm4_rd_icEnFej28YLqGppaQwTo1wrGQ",
  authDomain: "scover-6e7d3.firebaseapp.com",
  projectId: "scover-6e7d3",
  storageBucket: "scover-6e7d3.firebasestorage.app",
  messagingSenderId: "401956065968",
  appId: "1:401956065968:web:3a40f84aa7f63753706175",
  measurementId: "G-H70Z2S6YQS"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider };